export default "__VITE_PUBLIC_ASSET__60c0c292__"